<template>
<Main>
    <v-container>
        <v-card class="mx-auto">
            <v-card-text>
                <p class="display-1 text--primary">Summary Target(Branch)</p>
                <div class="text--primary">
                    <v-row>
                        <v-col md="3" sm="12">
                            <v-select color="red darken-1" v-model="SELECTED_MONTH_PERIOD" :items="VSELECT_MONTH_PERIOD" label="Month Period" dense outlined></v-select>
                        </v-col>
                        <v-col md="3" sm="12">
                            <v-select color="red darken-1" v-model="SELECTED_YEAR_PERIOD" :items="VSELECT_YEAR_PERIOD" label="Year Period" dense outlined></v-select>
                        </v-col>
                        <v-col md="3" sm="12">
                            <v-select color="red darken-1" item-text="BRANCH_CODE" item-value="BRANCH_CODE" v-model="SELECTED_BRANCH" :items="VSELECT_BRANCH" label="Select Branch" dense outlined></v-select>
                        </v-col>
                         <v-col md="3" sm="12">
                            <v-select color="red darken-1" item-text="STATUS_DESC" item-value="STATUS_DESC" v-model="SELECTED_STATUS" :items="VSELECT_STATUS" label="Select Status" dense outlined></v-select>
                        </v-col>
                        <v-col class="text-right" md="12">
                            <v-btn small color="warning" @click="getOverview()">Search Target Overview</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
        </v-card>

        <v-card class="mx-auto mt-3" v-show="isShowData">
                <v-card-text>
          <v-tabs
            color="white accent-4"
            fixed-tabs
            center
            background-color="indigo"
            dark
          >
            <v-tab>By Position</v-tab>
            <v-tab>By Lini</v-tab>

            <v-tab-item :key="1">
              <v-container fluid>
                <v-row>
                  <v-col md="12" class="mb-2">
                    <v-layout column style="height: 50vh">
                      <v-flex md12 style="overflow: auto">
                        <v-data-table
                          :headers="dtHeaderSummary"
                          :items="dtItemSummary"
                          :loading="dtLoading"
                          loading-text="Fetching Data..."
                          :hide-default-footer="true"
                          :hide-default-header="false"
                          class="elevation-1"
                          :items-per-page="100"
                        >
                          <template v-slot:item.SumTargetCabang="{ item }">
                            <span>{{
                              formatCurrency(item.SumTargetCabang)
                            }}</span>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                    <div class="text--primary">
                      <v-row>
                        <v-col md="2" sm="12"></v-col>
                        <v-col md="2" sm="12"></v-col>
                        <v-col md="3" sm="12"></v-col>
                        <v-col md="3" sm="12" style="margin-top: 20px">
                          <tr class="right-aligned-text">
                            <th style="font-size: 15px, marginBottom: 10px">
                              {{
                                formatCurrency(totals.SumTargetCabang)
                              }}
                            </th>
                          </tr>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab-item :key="2">
              <v-container fluid>
                <v-row>
                  <v-col md="12" class="mb-2">
                    <v-layout column style="height: 50vh">
                      <v-flex md12 style="overflow: auto">
                        <v-data-table
                          :headers="dtHeaderSummaryLini"
                          :items="dtItemSummaryLini"
                          :loading="dtLoading"
                          loading-text="Fetching Data..."
                          :hide-default-footer="true"
                          :hide-default-header="false"
                          class="elevation-1"
                          :items-per-page="100"
                        >
                          <template v-slot:item.VALUE_TGT_CAB="{ item }">
                            <span>{{
                              formatCurrency(item.VALUE_TGT_CAB)
                            }}</span>
                          </template>
                          <template v-slot:item.VALUE_TGT_HO="{ item }">
                            <span>{{ formatCurrency(item.VALUE_TGT_HO) }}</span>
                          </template>
                          <template v-slot:item.GAB="{ item }">
                            <span>{{ formatCurrency(item.GAB) }}</span>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-card-text>

            <div class="text--primary">
                    <v-row>
                        <v-col style="marginLeft:10px" md="12">
                            <v-btn color="warning" @click="downloadCSV()">Export Excel</v-btn>
                        </v-col>
                        <v-col md="12">
                            <v-data-table :headers="dtHeadersDetailTarget" :items="dtItemsDetailTarget" :search="search" :loading="dtLoading" loading-text="Fetching Data...">
                                  <template v-slot:item.VALUE_TGT_HO="{ item }">
                                   <span>{{ new Intl.NumberFormat('en-US').format(item.VALUE_TGT_HO) }}</span>
                                </template>
                                <template v-slot:item.VALUE_TGT_CAB="{ item }">
                                   <span>{{ new Intl.NumberFormat('en-US').format(item.VALUE_TGT_CAB) }}</span>
                                </template>
                                  <template v-slot:item.STATUS="{ item }">
                                   <span :style="{ color: item.STATUS === 'NEW' ? 'blue' : item.STATUS === 'APPROVE' ? 'green' : 'red' }">{{item.STATUS}}</span>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>

                    <!-- {{ this.dtItems }} -->
                </div>
        </v-card>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</Main>
</template>

<script>
import Main from "@/Main.vue";
import XLSX from "xlsx";
// const ;

export default {
    components: {
        Main
    },
    data() {
        return {
            VSELECT_STATUS: [
                { "STATUS_DESC": "NEW"},
                 { "STATUS_DESC": "APPROVE"},
                  { "STATUS_DESC": "REJECT"}
            ],
            dtHeaderSummary: [
                { text: "PERIOD", value: "period" },
                { text: "POSITION", value: "ROLE_POSITION_CODE" },
               // { text: "TOTAL TARGET HO", value: "SumTargetHO" },
                { text: "TOTAL TARGET Cabang", value: "SumTargetCabang" }
            ],
            dtHeaderSummaryLini: [
        { text: "PERIOD", value: "period" },
        { text: "LINI", value: "PRODUCT_SUB_LINE" },
        // { text: "TOTAL TARGET HO", value: "SumTargetHO" },
        { text: "TOTAL TARGET HO", value: "VALUE_TGT_HO" },
        { text: "TOTAL TARGET Cabang", value: "VALUE_TGT_CAB" },
        { text: "GAP", value: "GAB" },
      ],
            dtHeadersDetailTarget: [{
                    text: "Month Periode",
                    value: "TGT_MONTH_ID"
                },
                {
                    text: "Year Periode",
                    value: "TGT_YEAR_ID"
                },
                {
                    text: "Cabang",
                    value: "BRANCH_CODE"
                },
                {
                    text: "Item / Subline",
                    value: "PRODUCT_SUB_LINE"
                },
                {
                    text: "Channel Outlet Group",
                    value: "OUTLET_CHANNEL_GROUP"
                },
                {
                    text: "Sales Person Position",
                    value: "ROLE_POSITION_CODE"
                },
                {
                    text: "SUM TGT Rekomendasi HO",
                    value: "VALUE_TGT_HO"
                },
                {
                    text: "SUM TGT Cabang",
                    value: "VALUE_TGT_CAB"
                },
                {
                    text: "STATUS",
                    value: "STATUS"
                }
            ],
            dtItemSummary: [],
             dtItemSummaryLini: [],
            dtItemSummaryAll:[],
            SELECTED_MONTH_PERIOD: "",
            SELECTED_YEAR_PERIOD: "",
            SELECTED_BRANCH: "",
            SUMARY_HEADER_CABANG: "",
            VSELECT_MONTH_PERIOD: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            VSELECT_YEAR_PERIOD: [],
            VSELECT_BRANCH: [],
            VSELECT_STATUS:  [
                { "STATUS_DESC": "NEW"},
                 { "STATUS_DESC": "APPROVE"},
                  { "STATUS_DESC": "REJECT"}
            ],
            SELECTED_STATUS: "",
            dtItemsDetailTarget: [],
            SUMTarget: [],
            SumTargetHo: '',
            SumTargetCabang: '',
            search: "",
            dtLoading: false,
            isLoading: false,
            isShowSnackbar: false,
            snackbarText: "",
            isShowData: false
        };
    },
    mounted() {
        this.prepareData();
    },
    computed: {
    totals() {
      const totals = this.dtItemSummary.reduce((acc, d) => {
        acc.SumTargetHO += d.SumTargetHO
        acc.SumTargetCabang += parseInt(d.SumTargetCabang)
        return acc
      }, {
          SumTargetHO: 0,
          SumTargetCabang: 0
        })
      return totals
    }
   },
    methods: {
        prepareData() {
            const DATE_NOW = new Date();

            this.SELECTED_MONTH_PERIOD = DATE_NOW.getMonth() + 1;
            this.SELECTED_YEAR_PERIOD = DATE_NOW.getFullYear();

            let YEAR = [];
            for (let i = 2000; i < DATE_NOW.getFullYear() + 25; i++) {
                this.VSELECT_YEAR_PERIOD.push(i);
            }
            const USER_DATA = JSON.parse(localStorage.getItem("userData"));
            this.dtLoading = true;
            this.$http
                .get("/target/selectBranch", {
                    headers: {
                        "api-key": this.$apiKey
                    }
                })
                .then(res => {
                    this.dtLoading = false;
                    const data = res.data.data;
                    if(USER_DATA.ORG_ID==81){
                         this.VSELECT_BRANCH = data;
                    }else{
                        let dataFilter = data.filter(function(e){
                          return e.ORG_ID === USER_DATA.ORG_ID
                        })   
                        this.VSELECT_BRANCH = dataFilter;
                    } 
                })
                .catch(err => {
                    this.dtLoading = false;
                    this.showSnackbar(err.toString());
                });
        },
        getOverview() {
            this.SUMARY_HEADER_CABANG = this.SELECTED_BRANCH;
            let data = {
                MonthID: this.SELECTED_MONTH_PERIOD,
                YearID: this.SELECTED_YEAR_PERIOD,
                BranchCode: this.SELECTED_BRANCH,
                Status: this.SELECTED_STATUS
            };
            console.log('data ', data)
            this.dtItemSummary = [];
                        this.dtItemsDetailTarget = [];
            this.isLoading = true;
            this.$http
                .post("/target/overviewbranch", data, {
                    headers: {
                        "api-key": this.$apiKey
                    }
                })
                .then(res => {

                this.getOverviewLini()
                    const {
                        success,
                        message,
                        data
                    } = res.data;
                    if (success) {
                        this.isLoading = false;
                        this.isShowData = true;
                         let dataDetail = data.DetailTarget;

                         let dataSum = data.SUMTarget;
                            dataSum.forEach((val, index) => {
                               // console.log('rizki ', dataSum[index].SumTargetCabang)
                                dataSum[index].period = `${dataSum[index].TGT_YEAR_ID}-${dataSum[index].TGT_MONTH_ID}`;
                               // dataSum[index].SumTargetCabang = dataSum[index].SumTargetCabang.toLocaleString();
                            });
                        this.dtItemSummary = dataSum;

                        this.dtItemsDetailTarget = dataDetail;
                        this.showSnackbar("Get Data Success...");
                    } else {
                        this.isLoading = false;
                        this.isShowData = false;
                        this.showSnackbar(message);
                    }
                })
                .catch(err => {
                    this.isLoading = false;
                    this.isShowData = false;
                    this.showSnackbar(err.toString());
                });
        },
         formatCurrency(value) {
      if (isNaN(value)) return value;
      return new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(value));
    },
    getOverviewLini() {
      this.SUMARY_HEADER_CABANG = this.SELECTED_BRANCH;
      let data = {
        MonthID: this.SELECTED_MONTH_PERIOD,
        YearID: this.SELECTED_YEAR_PERIOD,
        BranchCode: this.SELECTED_BRANCH,
        Status: this.SELECTED_STATUS,
      };
      console.log("data ", data);
      this.dtItemSummary = [];
      this.dtItemsDetailTarget = [];
      this.isLoading = true;
      this.$http
        .post("/target/overviewlini", data, {
          headers: {
            "api-key": this.$apiKey,
          },
        })
        .then((res) => {
          const { success, message, data } = res.data;
          if (success) {
            this.isLoading = false;
            this.isShowData = true;
            

            let dataSum = data.SUMTarget;
            dataSum.forEach((val, index) => {
              // console.log('rizki ', dataSum[index].SumTargetCabang)
              dataSum[
                index
              ].period = `${dataSum[index].TGT_YEAR_ID}-${dataSum[index].TGT_MONTH_ID}`;
              // dataSum[index].SumTargetCabang = dataSum[index].SumTargetCabang.toLocaleString();
            });
            this.dtItemSummaryLini = dataSum;

            this.showSnackbar("Get Data Success...");
          } else {
            this.isLoading = false;
            this.isShowData = false;
            this.showSnackbar(message);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.isShowData = false;
          this.showSnackbar(err.toString());
        });
    },
        downloadCSV() {       

          const workBook = XLSX.utils.book_new(); // create a new blank book
          let dataSum = this.dtItemsDetailTarget;
          dataSum.forEach((val, index) => {
                                dataSum[index].VALUE_TGT_CAB = parseInt(dataSum[index].VALUE_TGT_CAB);
                                dataSum[index].VALUE_TGT_HO = parseInt(dataSum[index].VALUE_TGT_HO);
                            });
          const workSheet = XLSX.utils.json_to_sheet(dataSum);
          XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
          XLSX.writeFile(workBook, "Summary Target.xls"); // initiate a file download in browser
    },
        showSnackbar(text) {
            this.snackbarText = text;
            this.isShowSnackbar = true;
        }
    }
};
</script>
